// extracted by mini-css-extract-plugin
export default {"module":"Modal_module__LkNd3","container":"Modal_container__zItPT","close":"Modal_close__HMOnl","content":"Modal_content__Mrtip"};